import React from 'react';
import type { Member } from '@hero/schema';
import { useMemberDrawerStore } from '@hero/hooks-shared';
import { TableCell } from '../../../ui/Table/Table';
import { MianAvatar } from '../../../app/MianAvatar';
import { MemberTypeBadge } from '../Status/MemberTypeBadge';
import { CellAction } from '../../../app/Table/CellAction';

export interface MemberRowProps {
  member: Member;
}

export const MemberRow: React.FC<MemberRowProps> = ({ member }) => {
  const openDrawer = useMemberDrawerStore(s => s.open);
  const handleClick = () => openDrawer(String(member._id));

  return (
    <>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <div className="flex items-center gap-3">
          <MianAvatar src="/images/avatar.png" className="size-[44px]" />
          {member.name}
        </div>
      </TableCell>
      <TableCell className="cursor-pointer text-gray-600 body2" onClick={handleClick}>
        <span dir="ltr">{member.phone}</span>
      </TableCell>
      <TableCell className="cursor-pointer" onClick={handleClick}>
        <MemberTypeBadge type={member.type} className="px-4 py-2" />
      </TableCell>
      <TableCell>
        <CellAction type="view" onClick={handleClick} />
      </TableCell>
    </>
  );
};
